import React from 'react';
import { Outlet } from 'react-router-dom';
// import MyAppBar from '../../Components/AppBar/CustomAppBar';
import CustomUserAppBar from '../../Components/AppBar/CustomUserAppBar';

const UserLayout = ({ dynamicLogo }) => {
  return (
    <>
      <CustomUserAppBar dynamicLogo={dynamicLogo}/>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default UserLayout;
